import * as React from "react";
import PropTypes from "prop-types";

const MapChip = ({ href, label }) => {
  if (!href) return null;
  const text = label || "Itinéraire depuis l’appartement";
  return (
    <a
      className="map-chip"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={text}
    >
      <span aria-hidden="true">📍</span>
      <span className="sr-only">{text}</span>
    </a>
  );
};

MapChip.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default MapChip;

